import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * DisconnectionType Partial Translation Cell
 * Translates disconnectionType enum into understandable values
 */
export const disconnectionTypePartial: Columns<any> = {
  title: 'Afbrydelsesart',
  key: 'disconnectionType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.disconnectiontype.notspecified',
    remotedisconnection: 'enum.meteringpoint.disconnectiontype.remotedisconnection',
    manualdisconnection: 'enum.meteringpoint.disconnectiontype.manualdisconnection',
  }
}
